<template>
  <a v-bind:href="href" :class="{ active: isActive }" v-on:click="go">
    <slot></slot>
  </a>
</template>

<script>
import { routes } from "../main";
export default {
  props: {
    href: {
      type: String,
      required: true
    },
    class: String
  },
  computed: {
    isActive() {
      return this.href === this.$root.currentRoute;
    }
  },
  methods: {
    go(event) {
      event.preventDefault();
      this.$root.currentRoute = this.href;
      window.history.pushState(null, routes[this.href], this.href);
    }
  }
};
</script>

<style scoped>
.active {
  border-color: #6875f5;
  color: #161e2e;
}
</style>
